const EVENTS = {
  SIDE_MENU_COLLAPSE: 'ui.action.menu.collapse',
  SIDE_MENU_EXPAND: 'ui.action.menu.expand',
  CLOSE_MENU: 'ui.action.close_menu',
  DISABLE_SPINNER: 'ui.global_spinner.disable',
  ENABLE_SPINNER: 'ui.global_spinner.enable',
  NAVIGATE: 'navigate',

  /**
   * Fresh appointment allowance for the current merchant.
   *
   * Carries the same object micro apps receive as the `appointmentLimit` flag
   * at create() time (see `getAppSettings`), so a listener can swap it straight
   * in for the flag it started with rather than reconciling two shapes.
   *
   * Emitted whenever the allowance in the store changes: when it first resolves
   * during bootstrap, and on every refetch after it (an appointment created, a
   * socket reconnect, the tab returning to the foreground). Elm micro apps take
   * their flags once at create() and cannot re-read them, so this is how a
   * widget already on screen learns the count has moved.
   */
  APPOINTMENT_USAGE_UPDATED: 'appointment_usage_updated',
} as const;

function dataEventBusMap(resourceName: string) {
  return {
    load: `data.${resourceName}.load`,
    success: `data.${resourceName}.success`,
    error: `data.${resourceName}.error`,
  };
}

export const API_EVENTS = {
  token: dataEventBusMap('token'),
};

export default EVENTS;
